import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { cpf } from "cpf-cnpj-validator";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  Icon,
  Button,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
} from "@mui/material";

import iconRevela from "../../images/iconRevela.svg";
import { Outlet } from "react-router-dom";

import {
  KeyboardArrowDown,
  Logout,
  PersonOutlineOutlined,
} from "@mui/icons-material";
import api from "../../services/api";
import { getItemDecrypt, localStorageRemoveItem } from "../../utils/cryptoData";

function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [usuario, setUsuario] = useState({
    co_id: 0,
    firtNameLastName: "",
    no_cns: "",
    no_cpf: "",
    no_email: "",
    no_nome_usuario: "",
  });
  const [isVinculo, setIsVinculo] = useState(false);
  const open = Boolean(anchorEl);

  useEffect(() => {
    let usuario = getItemDecrypt("usuario");

    if (usuario) {
      let vinculo = getItemDecrypt("vinculo_ativo");

      const partes = usuario.no_nome_usuario.split(" ");
      if (partes.length > 1) {
        const primeiroNome = partes[0];
        const ultimoNome = partes[partes.length - 1];
        usuario.firtNameLastName = `${primeiroNome} ${ultimoNome}`;
      } else {
        usuario.firtNameLastName = partes[0];
      }
      if (vinculo) {
        setIsVinculo(true);
      }

      setUsuario(usuario);
    } else {
      logout();
      clearLocalStorage();
    }
  }, [location.pathname]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const linkPerfil = () => {
    navigate("/cadastro");
  };

  const linkVinculos = () => {
    navigate("/vinculos");
  };

  const clearLocalStorage = () => {
    localStorage.removeItem("sabiaTokenExpirationTime");
    localStorage.removeItem("sabiaScope");
    localStorage.removeItem("sabiaToken");
    localStorage.removeItem("usuario");
    localStorage.removeItem("vinculo_ativo");
    localStorage.removeItem("jwt");
    localStorage.removeItem("paciente");
    // removendo com criptografia
    localStorageRemoveItem("usuario");
    localStorageRemoveItem("vinculo_ativo");
    localStorageRemoveItem("paciente");
    api.defaults.headers.authorization = null;
  };
  const logout = async () => {
    try {
      const { data } = await api.post(`/revoke-token/${usuario.co_id}`);
      clearLocalStorage();
      navigate("/");
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  return (
    <div>
      <Box height="80px"></Box>
      <AppBar
        position="fixed"
        sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          height: "80px",
          justifyContent: "center",
          boxShadow: "none",
        }}
      >
        <Container maxWidth="100vw" sx={{ backgroundColor: "#3E94C2" }}>
          <Toolbar>
            <Stack
              direction={"row"}
              width={"100%"}
              alignItems="center"
              height={{ xs: "30px", sm: "44px", md: "54px" }}
            >
              <Icon style={{ width: "auto", height: "100%" }}>
                <img
                  src={iconRevela}
                  style={{ width: "auto", height: "100%" }}
                  alt={"Icone Pep"}
                />
              </Icon>
              <Box
                sx={{
                  width: "50%",
                  alignSelf: "center",
                  justifyContent: "center",
                }}
              ></Box>
              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "40%",
                }}
                spacing={2}
              >
                <Tooltip title="Abrir Opções">
                  <Button
                    onClick={handleClick}
                    size="small"
                    variant="text"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    sx={{
                      textTransform: "capitalize",
                      color: "#fff",
                      fontSize: "1rem",
                    }}
                    startIcon={
                      <Avatar
                        sx={{
                          width: "40px",
                          height: "40px",
                          border: "1px solid",
                          borderColor: "#ffff",
                        }}
                      />
                    }
                    endIcon={
                      <KeyboardArrowDown
                        sx={{
                          width: "20px",
                          height: "20px",
                          color: "#fff",
                        }}
                      />
                    }
                  >
                    <Typography
                      text
                      display={{
                        xs: "none",
                        sm: "flex",
                        color: "#fff",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {usuario.firtNameLastName}
                    </Typography>
                  </Button>
                </Tooltip>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      p: 2,
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <Stack direction={"row"} gap={2}>
                    <Typography>
                      CPF: {cpf.format(usuario.no_cpf)} | CNS: {usuario.no_cns}
                    </Typography>
                  </Stack>

                  <Divider sx={{ mt: 2, mb: 2 }} />
                  {isVinculo && (
                    <>
                      <MenuItem
                        onClick={linkPerfil}
                        sx={{ color: "#1E729F", fontWeight: "bold", gap: 1 }}
                      >
                        <PersonOutlineOutlined fontSize="medium" /> Perfil
                      </MenuItem>
                      <MenuItem
                        onClick={linkVinculos}
                        sx={{ color: "#1E729F", fontWeight: "bold", gap: 1 }}
                      >
                        <PersonOutlineOutlined fontSize="medium" /> Meus
                        vínculos
                      </MenuItem>
                      <Divider />
                    </>
                  )}

                  <MenuItem
                    onClick={logout}
                    sx={{ color: "#1E729F", fontWeight: "bold" }}
                  >
                    <ListItemIcon
                      sx={{ color: "#1E729F", fontWeight: "bold", gap: 1 }}
                    >
                      <Logout fontSize="medium" /> Sair
                    </ListItemIcon>
                  </MenuItem>
                </Menu>
              </Stack>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
      <Box sx={{ backgroundColor: "#FFFFFFFF" }}>
        <Outlet />
      </Box>
    </div>
  );
}

export default NavBar;
